const ITEMS = [
  "Founding tasker intake",
  "Malta",
  "0% commission on your first 5 jobs or 60 days",
  "No fee · no exclusivity",
  "We call every professional personally",
];

export const Marquee = () => {
  const row = ITEMS.map((t, i) => (
    <span key={i}>
      {t} <em>·</em>
    </span>
  ));
  return (
    <div className="marquee" aria-hidden="true" data-testid="marquee">
      <div className="marquee-track">
        {row}
        {row.map((el, i) => ({ ...el, key: `b${i}` }))}
      </div>
    </div>
  );
};
